import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  rememberState (event) {
    const radio = this.#radioFromEvent(event)
    if (!radio) return

    radio.dataset.deselectableRadioWasChecked = radio.checked ? 'true' : 'false'
  }

  toggle (event) {
    const radio = this.#radioFromEvent(event)
    if (!radio) return
    if (radio.dataset.deselectableRadioWasChecked !== 'true') return

    radio.checked = false
    delete radio.dataset.deselectableRadioWasChecked
    event.preventDefault()
    radio.dispatchEvent(new Event('change', { bubbles: true }))
  }

  #radioFromEvent (event) {
    if (event.target.matches('input[type=radio]')) return event.target

    const label = event.target.closest('label')
    if (!label) return null

    return label.querySelector('input[type=radio]')
  }
}
